import { User } from '@intelligent-play-v2/domain';
import { queryBuilder } from '../queryBuilder';

export const getUsers = async (): Promise<User[]> => {
  const { data } = await queryBuilder('GET', 'admin/users');
  return data;
};
